import type { ScheduleMode, ScheduleModeConfig } from '../types';
import { manualModeConfig } from './manual';
import { adhocModeConfig } from './adhoc';
import { selfScheduleModeConfig } from './selfSchedule';
import { selfScheduleAdhocModeConfig } from './selfScheduleAdhoc';

export const MODE_CONFIGS: Record<ScheduleMode, ScheduleModeConfig> = {
  manual: manualModeConfig,
  adhoc: adhocModeConfig,
  'self-schedule': selfScheduleModeConfig,
  'self-schedule-adhoc': selfScheduleAdhocModeConfig,
};

export {
  manualModeConfig,
  adhocModeConfig,
  selfScheduleModeConfig,
  selfScheduleAdhocModeConfig,
};
